if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.init();
    }

    init() {
      function parseLocalizedPrice(priceString) {
        // Remove all non-numeric characters except comma and dot
        let sanitized = priceString.replace(/[^\d.,]/g, '');

        // If it contains both comma and dot, assume comma is thousand separator
        if (sanitized.includes(',') && sanitized.includes('.')) {
          sanitized = sanitized.replace(/,/g, '');
        }
        // If it only contains comma, assume it's a decimal separator
        else if (sanitized.includes(',') && !sanitized.includes('.')) {
          sanitized = sanitized.replace(',', '.');
        }

        const result = parseFloat(sanitized);
        return isNaN(result) ? 0 : result;
      }

      const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));  
      //console.log( this.getAttribute('data-cart-total-amount') );    
      const cartTotal = parseLocalizedPrice(this.getAttribute('data-cart-total-amount'));
      //console.log( cartTotal );
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));      
      let shippingMessage = '';
      let shippingSuccess = false;
      //console.log( freeShippingThreshold * Shopify.currency.rate );  
      //console.log( freeShippingRemaining );  
      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.shippingNoticeStrings.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining*100), window.settings.shop_money_format));        
      } else {                
        shippingMessage = this._decodeHTMLEntities(window.shippingNoticeStrings.shipping_notice_eligible_for_free);
        shippingSuccess = true;
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}">
            ${shippingMessage}
          </div>`;
      } else {
        this.innerHTML = shippingMessage;
      }

      // Update the progress bar
      this._updateProgressBar(cartTotal, freeShippingThreshold);
    }

    _updateProgressBar(cartTotal, threshold) {
      // Calculate progress percentage
      const adjustedThreshold = Math.round(threshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const progress = Math.min((cartTotal / adjustedThreshold) * 100, 100);
      
      // Find the cart notice bar (it's a sibling element)
      const cartNoticeBar = this.parentElement?.querySelector('.cart-notice-bar');
      
      if (cartNoticeBar) {
        // Set CSS custom property for the width
        cartNoticeBar.style.setProperty('--progress-width', `${progress}%`);
      }
    }

    // Helper function to decode HTML entities
     _decodeHTMLEntities(text) {
      const textArea = document.createElement('textarea');
      textArea.innerHTML = text;
      return textArea.value;
    }
    
    _formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') == 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}